import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class OrionTower extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true

    var materialCristalesEdificio = new BABYLON.StandardMaterial('materialCristalesEdificioOrion', window.scene)
    materialCristalesEdificio.emissiveTexture = new BABYLON.Texture('static/textures/ventanalesEdificio.png', window.scene)
    materialCristalesEdificio.emissiveTexture.uScale = 2.0
    materialCristalesEdificio.emissiveTexture.vScale = 60.0
    materialCristalesEdificio.backFaceCulling = false
    materialCristalesEdificio.reflectionTexture = new BABYLON.MirrorTexture('mirror', 512, window.scene, true)
    materialCristalesEdificio.reflectionTexture.mirrorPlane = new BABYLON.Plane(0, -1.0, 0, -10.0)
    materialCristalesEdificio.reflectionTexture = new BABYLON.CubeTexture('static/textures/TropicalSunnyDay', window.scene)
    materialCristalesEdificio.reflectionTexture.level = 0.75 // Select the level (0.0 > 1.0) of the reflection
    // materialCristalesEdificio.reflectionTexture.renderList = [objx];

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/OrionTower/', 'Towers-orion.babylon', window.scene, function (newMeshes, particleSystems) {
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 1000)
      newMeshes[14].removeLODLevel(null) // La torre

      // Asignación de materiales
      newMeshes[14].material = materialCristalesEdificio
    })
  }

  elevator (level) {
    console.log('Moviendo el ascensor al nivel ' + level)
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/OrionTower.js